import FacebookIcon from '@components/icons/facebookIconDark.svg';
import LinkedInIcon from '@components/icons/linkedinIconDark.svg';
import RedditIcon from '@components/icons/redditIconDark.svg';
import TelegramIcon from '@components/icons/telegramIconDark.svg';
import XIcon from '@components/icons/xIconDark.svg';
import { ReactElement } from 'react';
import { LinkArticle } from './LinkArticle/LinkArticle';

export const socials = [
  {
    name: 'Link',
    icon: (articleLink: string, hoverColor: string): ReactElement => (
      <LinkArticle linkAsIcon articleLink={articleLink} hoverColor={hoverColor} />
    ),
    color: '#A7A7A7',
  },
  {
    name: 'Facebook',
    icon: <FacebookIcon />,
    socialLink: 'https://www.facebook.com/sharer/sharer.php?u=',
    textPrefix: '&quote=',
    color: '#1877f2',
  },
  {
    name: 'Twitter',
    icon: <XIcon />,
    socialLink: 'https://twitter.com/intent/tweet?url=',
    textPrefix: '&text=',
    color: '#1da0f1',
  },
  {
    name: 'Linkedin',
    icon: <LinkedInIcon />,
    socialLink: 'https://www.linkedin.com/shareArticle?mini=true&url=',
    color: '#0961b8',
  },
  {
    name: 'Telegram',
    icon: <TelegramIcon />,
    socialLink: 'https://t.me/share/url?url=',
    textPrefix: '&text=',
    color: '#28a4e2',
  },
  {
    name: 'Reddit',
    icon: <RedditIcon />,
    socialLink: 'https://www.reddit.com/submit?url=',
    textPrefix: '&title=',
    color: '#ff4300',
  },
];
